import { InputNumber } from "antd"
import { useEffect, useRef, useState } from "react"
import styles from "./styles.module.less";
import classNames from "classnames"
import { CloseOutlined } from "@ant-design/icons"
import { UnitEntity } from "@/services/unitSet/unitSet.model"
import { useDimUnits } from "@/pages/Project/hooks/useDimUnits"
import { NumberInputWithUnit } from "./NumberInputWithUnit"
import { numberFixTo, numberFixToStr } from "../FlowSheetEditor/components/RightPanel/UnitPanel/components/common/utils"
import isNumber from 'lodash/isNumber'

export enum Alignment {
  Left,
  Center,
  Right,
}

const classMap = {
  [Alignment.Left]: styles.alignLeft,
  [Alignment.Center]: styles.alignCenter,
  [Alignment.Right]: styles.alignRight,
}

interface DivNumberInputProps {
  value?: number
  removeAble?: boolean
  unitEntity?: UnitEntity
  onChange?: (val: number) => void
  className?: string
  align?: Alignment
  onDelete?: () => void
  dimCode?: string
  style?: any
}
export const DivNumberInput = (props: DivNumberInputProps) => {
  const {value: initValue, onChange, className, align = Alignment.Right, removeAble, onDelete, dimCode, unitEntity, style} = props
  const [value, setValue] = useState<number | undefined>(initValue)
  const [isEdit, setIsEdit] = useState(false)
  const ref = useRef<HTMLInputElement>(null)

  const units = useDimUnits(dimCode)

  useEffect(() => {
    setValue(initValue)
  }, [initValue])

  useEffect(() => {
    if (isEdit === true) {
      ref.current?.focus()
    }
  }, [isEdit])

  const onBlur = () => {
    setIsEdit(false)
    if (value === initValue) {
      return;
    }
    if (value !== undefined) {
      onChange?.(value)
    } else {
      removeAble && onDelete?.()
    }
  }

  const onEnd = (val: number | undefined) => {
    setIsEdit(false)
    if (val && unitEntity) {
      val = numberFixTo(val, unitEntity.cutoff)
    }
    setValue(val ?? undefined)
    if (val === initValue) return;
    if (val !== undefined) {
      onChange?.(val!)
    } else {
      removeAble && onDelete?.()
    }
  }

  const isUnitAble = units.length !== 0
  const alignClass = classMap[align]
  return <div className={classNames(styles.container, className, 'hover-delete-container')}>
    {!isEdit && <div style={style ?? {width: 100}} className={classNames(styles.editor, styles.valueWarp, alignClass)} onClick={() => setIsEdit(true)}>{isNumber(value) ? numberFixToStr(value as number, unitEntity?.cutoff ?? 4): value ?? '-' }</div>}
    {isEdit && !isUnitAble && <InputNumber style={style ?? {width: 100}} ref={ref} type="text" className={styles.editor} onBlur={onBlur} value={value} onChange={(val) => setValue(val ?? undefined)}/>}
    {isEdit && isUnitAble && <NumberInputWithUnit unit={unitEntity?.unit!} units={units} value={value} onEnd={onEnd} />}
    {removeAble && !isEdit && <div className={classNames(styles.removeIcon, 'hover-delete')} onClick={onDelete}><CloseOutlined /></div>}
  </div>
}